module.exports = __webpack_public_path__ + "img/image (5).37ee1574.jpg";